// Standard predefined products for Universal Electricals & Electronics
// Used in Quotations, Proforma Invoices, and Purchase Orders to auto-populate
// Product Name, Description (details), and HSN Code.

export const STANDARD_PRODUCTS = [
  {
    name: "Proximity Warning Device",
    description: "Radar Based (Single) Sensor, Detection Range 10–12 MTR, Operating Voltage: 12–36VDC",
    hsn_code: "8531",
  },
  {
    name: "Driver Fatigue Monitoring System",
    description: "Offline Device",
    hsn_code: "8524",
  },
  {
    name: "Anti Tilt Device",
    description: "With Dalla & Break Interlocking System",
    hsn_code: "8531",
  },
  {
    name: "Automatic Fire Detection Suppression System",
    description: "25LBS, 6 Nozzle, Single Zone System",
    hsn_code: "8704",
  },
  {
    name: "Rear View Camera System",
    description: '7" HD Display, 1080P Resolution, IP69K Grade 2MP Camera, 15 MTR Connecting Cable',
    hsn_code: "8525",
  },
  {
    name: "Body Lifting Alarm (System)",
    description: "Body Lifting Alarm System",
    hsn_code: "8531",
  },
  {
    name: "Seat Belt Voice Reminder",
    description: "With Electronic Latch, Human Voice (Hindi & English), Working Voltage: 12–24VDC",
    hsn_code: "8531",
  },
  {
    name: "Audio Visual Alarm",
    description: "Dual Piezo Buzzer, Blinking Red LED, Operating Voltage: 12–36VDC",
    hsn_code: "8531",
  },
  {
    name: "Battery Cut-Off Switch",
    description: "Battery Cut-Off Switch",
    hsn_code: "8536",
  },
  {
    name: "Travel Alarm",
    description: "Travel Alarm System",
    hsn_code: "8531",
  },
];
